import ButtonList from "./buttonList/ButtonList";
import SearchBar from "./searchBar/SearchBar";
import "./DocumentSharing.css";
import DocumentBucket from "./documentBucket/DocumentBucket";
import { useCallback, useContext, useEffect, useState } from "react";
import { IAdminDocument } from "../../../../@types/documentAdmnstration.types";
import { api } from "../../../../utils/api";
import { trackPromise } from "react-promise-tracker";
import { AuthContext, UIContext } from "../../../../contexts";
import { ADMIN_DASHBOARD_HEADER } from "../../../../constants/caption/dashboardHeader";
import { IFolderPathProps } from "../../../../@types/components/filePathProps.types";
import { IAdminDocumentPayload } from "../../../../@types/adminDocumentPayload.types";
import DocumentsModal from "../../../shared/documentsModal/DocumentsModal";
import FileDrop from "./fileDrop/FileDrop";
import { Backdrop, Theme, createStyles, makeStyles } from "@material-ui/core";
import { ThreeCircles } from "react-loader-spinner";

const backdropStyles = makeStyles((theme: Theme) =>
	createStyles({
		backdrop: {
			zIndex: theme.zIndex.drawer + 1,
			color: "#fff",
			position: "absolute"
		}
	})
);

const DocumentSharing = () => {
	const backdropClasses = backdropStyles();
	const [documentList, setDocumentList] = useState<IAdminDocument[]>([]);
	const [allDocumentList, setAllDocumentList] = useState<IAdminDocument[]>([]);
	const [uploadedFile, setUploadedFile] = useState<File | null>(null);
	const [searchedFile, setSearchedFile] = useState<string>("");
	const [loading, setLoading] = useState<boolean>(false);
	const [open, setOpen] = useState<boolean>(false);
	const [path, setPath] = useState<IFolderPathProps[]>([
		{
			folder_id: "root",
			folder_name: "Home"
		}
	]);
	const [adminPayload, setAdminPayload] = useState<IAdminDocumentPayload>({
		group_owner_object_id: "",
		SSN: "",
		document_date: new Date(),
		document_purpose: "",
		parent_folder_id: "root",
		root_folder_id: "root"
	});
	const { user } = useContext(AuthContext);
	const { setDashboardHeader, setSelectedTab } = useContext(UIContext);

	const permission = (user as any)?.permissions.filter((permission: any) => permission.group_number === 0);
	const documentSharingPermission =
		permission && permission.length > 0
			? permission[0]?.permission_and_subscription.permissions.settings_menu.document_sharing_sub.self
			: null;
	// console.log(permission, "user", documentSharingPermission);
	const getAllDocumentList = useCallback(
		async (parent_folder_id: string) => {
			if (user?._id) {
				const filter = {
					group_owner_object_id: user?._id,
					parent_folder_id: parent_folder_id
				};
				try {
					setLoading(true);
					const response = await trackPromise(api.documentSharing.getUploadedDocumentList(filter));
					if (response) {
						// console.log(response);
						setDocumentList(response);
					}
				} catch (error) {
					console.log(error);
				} finally {
					setLoading(false);
				}
			}
		},
		[user]
	);

	const handleSearchFile = useCallback(
		(event: any, newValue: string | null) => {
			// console.log(newValue);
			if (newValue) {
				const regex = new RegExp(newValue, "i"); // "i" flag for case-insensitive search
				// eslint-disable-next-line arrow-parens
				const matchingDocuments = allDocumentList.filter((documents) => regex.test(documents.name));
				// Display the matching files
				// console.log(matchingDocuments);
				setDocumentList(matchingDocuments);
			} else {
				setSearchedFile("");
				getAllDocumentList("root");
			}
		},
		[allDocumentList, getAllDocumentList]
	);

	const getAllDocumentNameList = useCallback(async () => {
		if (user?._id) {
			const filter = {
				group_owner_object_id: user?._id
			};
			try {
				setLoading(true);
				const allDocumentListResponse = await trackPromise(api.documentSharing.getUploadedDocumentList(filter));
				if (allDocumentListResponse) {
					setAllDocumentList(allDocumentListResponse);
				}
			} catch (error) {
				console.log(error);
			} finally {
				setLoading(false);
			}
		}
	}, [user]);
	// const get

	const handleChangeFolder = async (parent_folder_id: string, parent_folder_name: string) => {
		const _storedArray: any[] = [];
		_storedArray.push(...path, { folder_id: parent_folder_id, folder_name: parent_folder_name });
		setPath(_storedArray);
	};
	const redirectFolder = (index: number) => {
		const newPath = path.slice(0, index + 1);
		setPath(newPath);
	};

	const handleChangeSetFile = (file: File) => {
		if (file) {
			setUploadedFile(file);
		}
	};

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
	const handleUploadFile = useCallback(async () => {
		const formData = new FormData();
		if (uploadedFile) {
			formData.append("document_attachment", uploadedFile);
		}
		if (user?.SSN && user._id) {
			adminPayload.SSN = user.SSN;
			adminPayload.group_owner_object_id = user._id;
			adminPayload.parent_folder_id = path[path.length - 1].folder_id;
			formData.append("admin_document_payload", JSON.stringify(adminPayload));
			try {
				setLoading(true);
				const response = await trackPromise(api.documentSharing.adminFileUpload(formData));
				if (response) {
					setDocumentList([...documentList, response]);
				}
			} catch (error) {
				console.log(error);
			} finally {
				setLoading(false);
			}
		} else alert("Some thing went wrong");
	}, [uploadedFile, user?.SSN, user?._id, adminPayload]);

	useEffect(() => {
		getAllDocumentList(path[path.length - 1].folder_id);
	}, [getAllDocumentList, path]);

	useEffect(() => {
		getAllDocumentNameList();
	}, [getAllDocumentNameList]);

	useEffect(() => {
		if (uploadedFile) {
			handleUploadFile();
		}
	}, [handleUploadFile, uploadedFile]);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.document_administration);
	}, []);
	return (
		<div>
			<DocumentsModal
				open={open}
				child={
					<FileDrop
						child={<></>}
						handleChangeSetFile={handleChangeSetFile}
						handleClose={handleClose}
						open={open}
						key={0}
					/>
				}
				handleChangeSetFile={handleChangeSetFile}
				handleClose={handleClose}
				key={1}
			/>
			<div className="searchBarWithButtons">
				<SearchBar handleSearchFile={handleSearchFile} documentList={allDocumentList} />
				{documentSharingPermission && documentSharingPermission.create && (
					<ButtonList
						handleChangeSetFile={handleChangeSetFile}
						handleOpen={handleOpen}
						parent_folder_id={path[path.length - 1].folder_id}
						root_folder_id="root"
						documentList={documentList}
						setDocumentList={setDocumentList}
					/>
				)}
			</div>
			<DocumentBucket
				redirectFolder={redirectFolder}
				handleChangeFolder={handleChangeFolder}
				path={path}
				documentList={documentList}
				setAllDocumentList={setAllDocumentList}
				setDocumentList={setDocumentList}
			/>
			<Backdrop className={backdropClasses.backdrop} open={loading}>
				<ThreeCircles
					height="100"
					width="100"
					color="#4fa94d"
					wrapperStyle={{}}
					wrapperClass=""
					visible={true}
					ariaLabel="three-circles-rotating"
					outerCircleColor=""
					innerCircleColor=""
					middleCircleColor=""
				/>
			</Backdrop>
		</div>
	);
};

export default DocumentSharing;
